module.exports = __webpack_public_path__ + "static/media/background.a106d596.webp";